module.exports = __webpack_public_path__ + "static/img/fmsLogo.f6a4afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/fmsLogo.png
// module id = g3qX
// module chunks = 2